import type Address from './Address';

export enum PaymentMethod {
  credit_card = 'credit_card',
  ach = 'ach',
  net_terms = 'net_terms',
  customer_initiated = 'customer_initiated',
}

export enum OrderStatus {
  // order eligible to be claimed
  pending = 'pending',
  // order is unclaimed, but expired
  expired = 'expired',
  // order is claimed
  completed = 'completed',
  // order is cancelled or closed
  closed = 'closed',
  // order is ineligible to be claimed based on partner-specific logic
  // (e.g. Essence - 1 ring per year)
  ineligible = 'ineligible',
}

export interface OrderLineItem {
  sku?: string;
  quantity?: number;
  //the original unsized / unfinished sku code
  originalSku?: string;
}

export interface Order {
  agreesToShare?: boolean;
  isRequestingSizingKit?: boolean;
  hasUpdatedShippingAddress?: boolean;
  lineItems?: OrderLineItem[];
  netsuiteInternalId?: string;
  netsuiteOrderId?: string;
  orderComplete?: boolean;
  shippingAddress?: Address;
  orderDate?: string;
  //needed for updateRingSelection
  salesOrderId?: string;
  customerId?: string;
  channel?: string; // e.g. external id from netsuite
  orderStatus?: OrderStatus;
  paymentMethod?: PaymentMethod;
}
